
import router from "@/router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { computed, defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import KtUserRoleModal from "@/views/pages/admin/users/UserRoleModal.vue";
import KtUserViewModal from "@/views/pages/admin/users/UserViewModal.vue";
import moment from "moment";
import DropdownUsersFilter from "./DropdownUsersFilter.vue";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import AplicationTableAction from "@/components/table/ApplicationTableAction.vue";

interface Paging {
  page: number;
  perPage: number;
  pageCount: number;
  totalCount: number;
}

interface Filter {
  role: string;
  firstname: string;
  lastname: string;
}

export default defineComponent({
  name: "kt-widget-12",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD YYYY");
    },
  },
  components: {
    KtUserRoleModal,
    KtUserViewModal,
    DropdownUsersFilter,
    AplicationTableAction,
  },
  props: {
    widgetClasses: String,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    onMounted(() => {
      MenuComponent.reinitialization();
    });

    const tableColumns = ["user"];
    const tableCallFunction = Actions.GET_USERS;

    console.log(route.query);

    const paging = ref<Paging>({
      page: route.query.page ? Number(route.query.page) : 1,
      perPage: route.query.perPage ? Number(route.query.perPage) : 8,
      pageCount: 0,
      totalCount: 0,
    });

    const filter = ref<Filter>({
      role: route.query.role ? String(route.query.role) : "",
      firstname: route.query.firstname ? String(route.query.firstname) : "",
      lastname: route.query.lastname ? String(route.query.lastname) : "",
    });

    const handleCurrentChange = (val: number) => {
      console.log(`current page: ${val}`);
      paging.value.page = val;
      router.push({
        name: "admin-users-list",
        query: {
          page: paging.value.page,
          perPage: paging.value.perPage,
          role: route.query.role ? String(route.query.role) : "",
          firstname: route.query.firstname ? String(route.query.firstname) : "",
          lastname: route.query.lastname ? String(route.query.lastname) : "",
        },
      });
      store.dispatch(Actions.GET_USERS, {
        params: {
          Page: paging.value.page,
          RecordsPerPage: paging.value.perPage,
          role: route.query.role ? String(route.query.role) : "",
          firstname: route.query.firstname ? String(route.query.firstname) : "",
          lastname: route.query.lastname ? String(route.query.lastname) : "",
        },
      });
    };

    onMounted(() => {
      console.log("mounted");
      store.dispatch(Actions.GET_USERS, {
        params: {
          Page: paging.value.page,
          RecordsPerPage: paging.value.perPage,
          role: route.query.role ? String(route.query.role) : "",
          firstname: route.query.firstname ? String(route.query.firstname) : "",
          lastname: route.query.lastname ? String(route.query.lastname) : "",
        },
      });
    });

    const editUser = (user) => {
      document.getElementById('fakeModalId')?.click();
      store.commit(Mutations.SET_ADMIN_USER_EDIT, user);
    };

    const viewUser = (user) => {
      store.commit(Mutations.SET_ADMIN_USER_EDIT, user);
    };

    const currentUsers = computed(() => {
      return store.getters.currentUsers != null && store.getters.currentUsers.data != null? store.getters.currentUsers.data : {};
    });

    return {
      paging,
      currentUsers,
      handleCurrentChange,
      editUser,
      viewUser,
      tableColumns,
      tableCallFunction,
    };
  },
});
